export default {
    COMUM: {
        BUSCAR_LINK_EDITAR_USUARIO: 'buscarLinkEditarUsuario',
        BUSCAR_LINK_SIGAPATRIMONIO: 'buscarLikSigaPatrimonio',
        BUSCAR_PRODUTO_POR_NOME: 'buscarProdutoPorNome',
        BUSCAR_USUARIO_LOGADO: 'buscarUsuarioLogado',
        BUSCAR_TODOS_ORGAOS: 'buscarTodosOrgaos',
        BUSCAR_ORGAOS: 'buscarOrgaos',
        BUSCAR_SETORES: 'buscarSetores',
        BUSCAR_FORNECEDORES: 'buscarFornecedores',
        BUSCAR_FORNECEDOR_POR_ID: 'buscarFornecedorPorId',
        BUSCAR_PARAMETROS: 'buscarParametros',
        BUSCAR_FUSO_HORARIO: 'buscarFusoHorario',
        BUSCAR_DADOS_SESSAO_USUARIO: 'buscarDadosSessaoUsuario',
    },
    PATRIMONIO: {
        BUSCAR_PATRIMONIO_POR_ID: 'buscarPatrimonio',
        BUSCAR_TODOS_PATRIMONIOS: 'buscarTodosPatrimonios',
        CADASTRAR_PATRIMONIO: 'cadastrarPatrimonio',
        ATUALIZAR_PATRIMONIO: 'atualizarPatrimonio',
        DELETAR_PATRIMONIO: 'deletarPatrimonio',
        DELETAR_PATRIMONIO_NAO_ALTERADO: 'deletarPatrimonioNaoAlterado',
        REVERTER_ATIVACAO: 'reverterAtivacao',
        ATIVA_PATRIMONIO: 'ativaPatrimonio',
        VISUALIZAR_PATRIMONIO_POR_ID: 'visualizarPatrimonioPorId',
        BUSCAR_AMORTIZACOES: 'buscarAmortizacoes',
        BAIXAR_RELATORIO_LISTAGEM_PATRIMONIO_XLS:
            'baixarRelatorioListagemPatrimonioXls',
        DOCUMENTO: {
            BUSCAR_DOCUMENTOS: 'buscarDocumentosPatrimonio',
            ATUALIZAR_DOCUMENTO: 'atualizarDocumentoPatrimonio',
            BUSCAR_TIPO_DOCUMENTO: 'buscarTipoDocumentoPatrimonio',
            CADASTRAR_DOCUMENTO: 'cadastrarDocumentoPatrimonio',
            DELETAR_DOCUMENTO: 'deletarDocumentoPatrimonio',
            DOCUMENTO_UPLOAD: 'documentoUploadPatrimonio',
            DOCUMENTO_DOWNLOAD: 'documentoDownloadPatrimonio',
            VALIDAR_UNICO_NUMERO_DOCUMENTO:
                'validarUnicoNumeroDocumentoPatrimonio',
        },
    },
    DOCUMENTO: {
        BUSCAR_LICENCA_LACUNA_FLOWBEE: 'buscarLicencaLacunaFlowbeeDocumento',
        INICIAR_ASSINATURA_DIGITAL: 'iniciarAssinaturaDigitalDocumento',
        FINALIZAR_ASSINATURA_DIGITAL: 'finalizarAssinaturaDigitalDocumento',
        ASSINATURA_ELETRONICA: 'assinaturaEletronicaDocumento',
        BUSCAR_DOCUMENTOS: 'buscarDocumentos',
        BUSCAR_TIPOS_DOCUMENTO: 'buscarTiposDocumento',
        ENVIAR_DOCUMENTO: 'enviarDocumento',
        DELETAR_DOCUMENTO: 'deletarDocumento',
        BAIXAR_DOCUMENTO: 'baixarDocumento',
        BUSCAR_SIGNATARIOS: 'buscarSignatarios',
        CONVIDAR_SIGNATARIOS: 'convidarSignatarios',
        REMOVER_SIGNATARIO: 'removerSignatario',
    },
    CONTA_CONTABIL: {
        BUSCAR_TODAS_CONTAS_CONTABEIS: 'buscarTodasContasContabeis',
        BUSCAR_CONTA_CONTABIL_POR_ID: 'buscarContaContabilPorId',
        SALVAR_CONTA_CONTABIL: 'salvarContaContabil',
        EDITAR_CONTA_CONTABIL: 'editarContaContabil',
    },
    AMORTIZACAO: {
        GERAR_AMORTIZACAO_MANUAL: 'gerarAmortizacaoManual',
    },
    RELATORIO: {
        BAIXAR_RELATORIO_INVENTARIO_ANALITICO_PDF:
            'baixarRelatorioInventarioAnaliticoPdf',
        BAIXAR_RELATORIO_INVENTARIO_ANALITICO_XLS:
            'baixarRelatorioInventarioAnaliticoXls',
        BAIXAR_RELATORIO_INVENTARIO_SINTETICO_PDF:
            'baixarRelatorioInventarioSinteticoPdf',
        BAIXAR_RELATORIO_INVENTARIO_SINTETICO_XLS:
            'baixarRelatorioInventarioSinteticoXls',
        BAIXAR_RELATORIO_MEMORANDO_PDF: 'baixarRelatorioMemorandoPdf',
        BAIXAR_RELATORIO_MEMORANDO_MOVIMENTACAO_PDF: 'baixarRelatorioMemorandoMovimentacaoPdf',
        BAIXAR_RELATORIO_MEMORANDO_REAVALIACAO_PDF: 'baixarRelatorioMemorandoReavaliacaoPdf',
        BAIXAR_RELATORIO_MEMORANDO_AJUSTE_PDF: 'baixarRelatorioMemorandoAjustePdf',
        RELATORIOS_TCE: {
            GERAR_RELATORIOS_TCE: 'gerarRelatoriosTce',
        }
    },
    CAMPOS_PERSONALIZADOS: {
        GET_ALL_CAMPOS_PERSONALIZADOS: 'getAllCamposPersonlizados',
    },
    MOVIMENTACAO: {
        ATUALIZAR_MOVIMENTACAO: 'atualizarMovimentacao',
        BUSCAR_MOVIMENTACAO_POR_PATRIMONIO: 'buscarMovimentacaoPorPatrimonio',
        CADASTRAR_MOVIMENTACAO: 'cadastrarMovimentacao',
        ENVIAR_MOVIMENTACAO: 'enviarMovimentacao',
        DELETAR_MOVIMENTACAO: 'deletarMovimentacao',
        BUSCAR_MOVIMENTACAO_POR_ID: 'buscarMovimentacaoPorId',
        BUSCAR_TODAS_MOVIMENTACOES: 'buscarTodasMovimentacoes',
        BUSCAR_MOVIMENTACOES_PENDENTES: 'buscarMovimentacoesPendentes',
        BUSCAR_PATRIMONIO_POR_MOVIMENTACAO: 'buscarPatrimonioPorMovimentacao',
        RECEBER_MOVIMENTACAO: 'receberMovimentacao',
        REJEITAR_MOVIMENTACAO: 'rejeitarMovimentacao',
        DOCUMENTO: {
            CADASTRAR_DOCUMENTO_MOVIMENTACAO: 'cadastrarDocumentoMovimentacao',
            ATUALIZAR_DOCUMENTO_MOVIMENTACAO: 'atualizarDocumentoMovimentacao',
            DOCUMENTO_UPLOAD_MOVIMENTACAO: 'documentoUploadMovimentacao',
            BUSCAR_TIPO_DOCUMENTO_MOVIMENTACAO:
                'buscarTipoDocumentoMovimentacao',
            BUSCAR_DOCUMENTOS_MOVIMENTACAO: 'buscarDocumentosMovimentacao',
            DELETAR_DOCUMENTO_MOVIMENTACAO: 'deletarDocumentoMovimentacao',
        },
        BAIXA: {
            FINALIZAR_MOVIMENTACAO_BAIXA: 'finalizarMovimentacaoBaixa',
            BUSCAR_TODAS_MOVIMENTACOES_BAIXAS: 'buscarTodasMovimentacoesBaixas',
        },
    },
    REAVALIACAO: {
        CADASTRAR_REAVALIACAO: 'cadastrarReavaliacao',
        BUSCAR_REAVALIACAO_POR_PATRIMONIO: 'buscarReavaliacaoPorPatrimonio',
        BUSCAR_REAVALIACAO_POR_ID: 'buscarReavaliacaoPorId',
        EDITAR_REAVALIACAO: 'editarReavaliacao',
        BUSCAR_REAVALIACOES: 'buscarReavaliacoes',
    },
    AJUSTE: {
        CADASTRAR_NOVO_AJUSTE: 'cadastrarNovoAjuste',
        BUSCAR_AJUSTE_POR_ID: 'buscarAjustePorId',
        BUSCAR_TODOS_AJUSTES: 'BuscarTodosAjustes',
        BUSCAR_AJUSTE_POR_PATRIMONIO: 'buscarAjustePorPatrimonio'
    },
    DASHBOARD: {
        BUSCAR_TOTALIZADORES: 'buscarTotalizadores',
        BUSCAR_LICENCAS_PROXIMAS_A_VENCER: 'buscarLicencasProximasAVencer',
        BUSCAR_INTANGIVEIS_POR_ORGAO: 'buscarIntangiveisPorOrgao',
        BUSCAR_INTANGIEIS_POR_TIPO: 'buscarIntangiveisPorTipo',
    },
    FUNDO_ESPECIAL: {
        BUSCAR_FUNDOS: 'buscarFundos',
    },
    FONTE_FINANCIAMENTO: {
        BUSCAR_FONTES_FINANCIAMENTO: 'buscarFontesFinanciamento',
    },
    PROJETO: {
        BUSCAR_PROJETOS: 'buscarProjetos',
    },
    ACESSO_SISTEMA: {
        BUSCAR_ACESSOS_SISTEMAS: 'buscarAcessosSistemas'
    },
    CONFIGURACAO: {
        PARAMETROS: {
            BUSCAR_TODOS_PARAMETROS: 'buscarTodosParametros'
        },
    }
}
